import React, { useState } from 'react'
import Tippy from '@tippyjs/react';

const Users = ({listOfUsers}) =>{
    var numbering = 0
    const [currentPage, SetCurrentPage] = useState(1)
    const [postPerPage, SetPostPerPage] = useState(5)

    const indexOfLastItem = currentPage * postPerPage
    const indexOfFirstItem = indexOfLastItem - postPerPage
    const CurrentItems = listOfUsers.slice(indexOfFirstItem, indexOfLastItem)
    const nextButton = () => {
        if (indexOfLastItem < listOfUsers.length) {
            SetCurrentPage(currentPage + 1)
        }
    }

    const prevButton = () => {
        if (currentPage !== 1) {
            SetCurrentPage(currentPage - 1)
        }
    }
    return (
        <div className="text-center md:text-left mt-4 relative ">
        <div className="absolute top-0 w-full  overflow-auto h-80 bg-white rounded-md">
           <table className="divide-y text-sm  border-b border-gray-200 divide-gray-200">
           <thead>
                    <tr className= "text-gray-500">
                       <th className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                           #
                       </th>
                       <th className="  px-12 py-3 whitespace-nowrap  text-sm font-medium  ">
                           User Names
                       </th>
                       <th scope="col" className="  px-12 py-3 whitespace-nowrap  text-sm font-medium  ">
                          User Email
                       </th>
                       <th scope="col" className="  px-12 py-3 whitespace-nowrap  text-sm font-medium  ">
                          User Group
                       </th>
                       {/* <th scope="col" className=  " px-24 py-3 whitespace-nowrap  text-sm font-medium  ">
                           Actions
                       </th> */}
                   </tr>
               </thead>
               <tbody>
                 {
                   CurrentItems.map(singleUser => {
                    numbering += 1
                     return (
                       <tr key={singleUser.id} className="border-b border-gray-200 pt-4">
                 
                     <td className="px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                          <span className="text-sm text-left">{numbering}</span>
                     </td>
                   <td  className="px-12 py-3 whitespace-nowrap  text-sm font-medium  ">
                       <span className="text-sm text-left">{singleUser.name}</span>
                   </td>
                   <td  className="px-12 py-3 whitespace-nowrap  text-sm font-medium  ">
                       <span className="text-sm text-left">{singleUser.email}</span>
                   </td>
                   <td  className="px-12 py-3 whitespace-nowrap  text-sm font-medium  ">
                       <span className="text-sm text-left">{singleUser.group ? singleUser.group.display_name : ""}</span>
                   </td>
                   {/* <td  className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                    <div className="flex">
                    <Link to="" className="bg-wvrblue text-white p-1 ml-2 rounded-md">
                       <span className="ml-2 mr-2 font-thin">view</span>
                    </Link>
                    <Link to="" className="bg-wvrPrimary p-1 ml-2 rounded-md">
                       <span className="ml-2 mr-2 font-thin">edit</span>
                    </Link>
                     <Link to="" className="text-wvrDarkPrimaryL p-1 ml-2">
                       <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg></p>
                     </Link>
                    </div>
                  </td> */}
               </tr> 
                     )
                   })
                 }
                  
               </tbody>
           </table>
           <div className="my-4 mr-4">
                <ul className="flex flex-row gap-4 justify-end inline">
                    <li className="bg-wvrOrange text-white px-2 py-1 rounded-lg cursor-pointer" onClick={() => prevButton()}>
                        <div >Prev</div>
                    </li>
                    <li className="py-1">{currentPage}</li>
                    <li onClick={() => nextButton()} className="bg-wvrOrange text-white px-2 py-1 rounded-lg cursor-pointer">
                        <div >Next</div>
                    </li>
                </ul>
            </div>
        </div>
     </div>
    )
}

export default Users